import { SeriesTypeEnum } from "./type";

import { bar3dSeriesMark, barSeriesMark } from "../bar/constant";

import { lineSeriesMark } from "../line/constant";

import { scatterSeriesMark } from "../scatter/constant";

import { areaSeriesMark } from "../area/constant";

import { radarSeriesMark } from "../radar/constant";

import { pie3dSeriesMark, pieSeriesMark } from "../pie/constant";

import { roseSeriesMark } from "../rose/constant";

import { mapSeriesMark } from "../map/constant";

import { circularProgressSeriesMark } from "../progress/circular/constant";

import { linkSeriesMark } from "../link/constant";

import { dotSeriesMark } from "../dot/constant";

import { wordCloudSeriesMark } from "../word-cloud/constant";

import { funnel3dSeriesMark, funnelSeriesMark } from "../funnel/constant";

import { linearProgressSeriesMark } from "../progress/linear/constant";

import { waterfallSeriesMark } from "../waterfall/constant";

import { boxPlotSeriesMark } from "../box-plot/constant";

import { treemapSeriesMark } from "../treemap/constant";

import { sankeySeriesMark } from "../sankey/constant";

import { gaugePointerSeriesMark, gaugeSeriesMark } from "../gauge/constant";

import { sunburstSeriesMark } from "../sunburst/constant";

import { rangeColumn3dSeriesMark, rangeColumnSeriesMark } from "../range-column/constant";

import { circlePackingSeriesMark } from "../circle-packing/constant";

import { heatmapSeriesMark } from "../heatmap/constant";

import { correlationSeriesMark } from "../correlation/constant";

import { rangeAreaSeriesMark } from "../range-area/constant";

import { baseSeriesMark } from "../base/constant";

import { LiquidSeriesMark } from "../liquid/constant";

import { vennSeriesMark } from "../venn/constant";

export var SeriesTypeForThemeEnum;

!function(SeriesTypeForThemeEnum) {
    SeriesTypeForThemeEnum.area_horizontal = "area_horizontal", SeriesTypeForThemeEnum.area_vertical = "area_vertical", 
    SeriesTypeForThemeEnum.area_stack = "area_stack", SeriesTypeForThemeEnum.line_horizontal = "line_horizontal", 
    SeriesTypeForThemeEnum.line_vertical = "line_vertical", SeriesTypeForThemeEnum.line_stack = "line_stack", 
    SeriesTypeForThemeEnum.bar_horizontal = "bar_horizontal", SeriesTypeForThemeEnum.bar_vertical = "bar_vertical", 
    SeriesTypeForThemeEnum.bar_stack = "bar_stack", SeriesTypeForThemeEnum.bar3d_horizontal = "bar3d_horizontal", 
    SeriesTypeForThemeEnum.bar3d_vertical = "bar3d_vertical", SeriesTypeForThemeEnum.bar3d_stack = "bar3d_stack", 
    SeriesTypeForThemeEnum.rangeColumn_horizontal = "rangeColumn_horizontal", SeriesTypeForThemeEnum.rangeColumn_vertical = "rangeColumn_vertical", 
    SeriesTypeForThemeEnum.rangeColumn3d_horizontal = "rangeColumn3d_horizontal", SeriesTypeForThemeEnum.rangeColumn3d_vertical = "rangeColumn3d_vertical", 
    SeriesTypeForThemeEnum.rangeArea_horizontal = "rangeArea_horizontal", SeriesTypeForThemeEnum.rangeArea_vertical = "rangeArea_vertical", 
    SeriesTypeForThemeEnum.linearProgress_horizontal = "linearProgress_horizontal", 
    SeriesTypeForThemeEnum.linearProgress_vertical = "linearProgress_vertical", SeriesTypeForThemeEnum.linearProgress_stack = "linearProgress_stack", 
    SeriesTypeForThemeEnum.boxPlot_horizontal = "boxPlot_horizontal", SeriesTypeForThemeEnum.boxPlot_vertical = "boxPlot_vertical", 
    SeriesTypeForThemeEnum.sankey_horizontal = "sankey_horizontal", SeriesTypeForThemeEnum.sankey_vertical = "sankey_vertical", 
    SeriesTypeForThemeEnum.waterfall_horizontal = "waterfall_horizontal", SeriesTypeForThemeEnum.waterfall_vertical = "waterfall_vertical", 
    SeriesTypeForThemeEnum.circularProgress_stack = "circularProgress_stack", SeriesTypeForThemeEnum.radar_stack = "radar_stack", 
    SeriesTypeForThemeEnum.rose_stack = "rose_stack";
}(SeriesTypeForThemeEnum || (SeriesTypeForThemeEnum = {}));

export const seriesMarkInfoMap = {
    [SeriesTypeEnum.bar]: barSeriesMark,
    [SeriesTypeEnum.bar3d]: bar3dSeriesMark,
    [SeriesTypeEnum.line]: lineSeriesMark,
    [SeriesTypeEnum.scatter]: scatterSeriesMark,
    [SeriesTypeEnum.area]: areaSeriesMark,
    [SeriesTypeEnum.radar]: radarSeriesMark,
    [SeriesTypeEnum.pie]: pieSeriesMark,
    [SeriesTypeEnum.pie3d]: pie3dSeriesMark,
    [SeriesTypeEnum.rose]: roseSeriesMark,
    [SeriesTypeEnum.geo]: baseSeriesMark,
    [SeriesTypeEnum.map]: mapSeriesMark,
    [SeriesTypeEnum.circularProgress]: circularProgressSeriesMark,
    [SeriesTypeEnum.link]: linkSeriesMark,
    [SeriesTypeEnum.dot]: dotSeriesMark,
    [SeriesTypeEnum.wordCloud]: wordCloudSeriesMark,
    [SeriesTypeEnum.wordCloud3d]: wordCloudSeriesMark,
    [SeriesTypeEnum.funnel]: funnelSeriesMark,
    [SeriesTypeEnum.funnel3d]: funnel3dSeriesMark,
    [SeriesTypeEnum.linearProgress]: linearProgressSeriesMark,
    [SeriesTypeEnum.waterfall]: waterfallSeriesMark,
    [SeriesTypeEnum.boxPlot]: boxPlotSeriesMark,
    [SeriesTypeEnum.treemap]: treemapSeriesMark,
    [SeriesTypeEnum.sankey]: sankeySeriesMark,
    [SeriesTypeEnum.gauge]: gaugeSeriesMark,
    [SeriesTypeEnum.gaugePointer]: gaugePointerSeriesMark,
    [SeriesTypeEnum.sunburst]: sunburstSeriesMark,
    [SeriesTypeEnum.rangeColumn]: rangeColumnSeriesMark,
    [SeriesTypeEnum.rangeColumn3d]: rangeColumn3dSeriesMark,
    [SeriesTypeEnum.circlePacking]: circlePackingSeriesMark,
    [SeriesTypeEnum.heatmap]: heatmapSeriesMark,
    [SeriesTypeEnum.correlation]: correlationSeriesMark,
    [SeriesTypeEnum.rangeArea]: rangeAreaSeriesMark,
    [SeriesTypeEnum.liquid]: LiquidSeriesMark,
    [SeriesTypeEnum.venn]: vennSeriesMark
};
//# sourceMappingURL=theme.js.map
